import axios from "axios";
import { API_URL } from "../index";

// FE-84: Services.js'ten taşındı (3 uç). Metotlar Services nesnesinde birleşir; this.X çağrıları çalışır.
// Admin Bildirim Merkezi uçları (30.10.2026, /notification-center). BE: notification-broadcasts.php; hepsi yalnız admin.
const adminBildirim = (token, action, data = {}) =>
  axios({
    method: "post",
    url: `${API_URL}flow/${action}`,
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    data,
  });

const servisBildirim = {

  GetAdminNotificationTemplates(token) {
    return adminBildirim(token, "get-admin-notification-templates");
  },

  // templateID varsa günceller, yoksa yeni şablon açar. {templateID?, title, content}
  SaveAdminNotificationTemplate(token, payload) {
    return adminBildirim(token, "save-admin-notification-template", payload);
  },

  DeleteAdminNotificationTemplate(token, templateID) {
    return adminBildirim(token, "delete-admin-notification-template", { templateID });
  },

  // {customers, partners, all} — aktif kullanıcı sayıları
  GetAdminNotificationAudience(token) {
    return adminBildirim(token, "get-admin-notification-audience");
  },

  SearchAdminNotificationRecipients(token, q) {
    return adminBildirim(token, "search-admin-notification-recipients", { q });
  },

  // Kampanya firması seçici: [{companyID, title, customerCount}] (customerCount = "firmanın müşterileri" kitlesi)
  GetAdminNotificationCompanies(token) {
    return adminBildirim(token, "get-admin-notification-companies");
  },

  // {audience: customers|partners|all|users|company_customers, userIDs?, companyID?, content, templateID?} → {broadcastID, recipientCount, pushCount}
  // companyID: company_customers kitlesinde ya da metinde {campaignCompany} varsa zorunlu.
  SendAdminNotification(token, payload) {
    return adminBildirim(token, "send-admin-notification", payload);
  },

  GetAdminNotificationHistory(token, limit = 50) {
    return adminBildirim(token, "get-admin-notification-history", { limit });
  },

  // Planlı bildirimler (02.11.2026): ileri tarihte bir kez ya da her yıl. Gönderimi BE cron'u yapar.
  GetAdminNotificationSchedules(token) {
    return adminBildirim(token, "get-admin-notification-schedules", {});
  },

  /** payload: {scheduleID?, audience, content, userIDs?, companyID?, templateID?, repeat: once|yearly, date: YYYY-MM-DD, time: HH:MM} */
  SaveAdminNotificationSchedule(token, payload) {
    return adminBildirim(token, "save-admin-notification-schedule", payload);
  },

  SetAdminNotificationScheduleStatus(token, scheduleID, status) {
    return adminBildirim(token, "set-admin-notification-schedule-status", { scheduleID, status });
  },

  DeleteAdminNotificationSchedule(token, scheduleID) {
    return adminBildirim(token, "delete-admin-notification-schedule", { scheduleID });
  },


  GetUserNotifications(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-user-notifications`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },

  SetUserNotificationAsRead(token, notificationID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/set-user-notification-as-read`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        notificationID
      }
    });
  },

  SetAllUserNotificationsAsRead(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/set-all-user-notifications-as-read`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },
};

export default servisBildirim;
